// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"6f3d859e","320":"4405902b","604":"b26fbdec","616":"a220e87e","849":"2af22367","875":"fd9ee2b0","950":"e6e14848"}[chunkId] + ".chunk.js";
};